import React from 'react';
import classNames from 'classnames';

/**
 * The `<SummaryStatsHeader>` handles the rendering of header for
 * summary stats data.
 */
export default function SummaryStatsHeader({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <h3 className={classNames('pb-1 type-h3', className)}>{children}</h3>;
}
